import { useEffect, useState } from "react";
import { useAddRefundPolicyMutation, useUpdateRefundPolicyMutation, useGetRefundPolicyDataQuery } from "../../../Services/PrivacyPolicy";
import { Editor } from "@tinymce/tinymce-react";

function AddStock() {
    const [detailedDescription, setDetailedDescription] = useState("");

    const [errors, setErrors] = useState({});

    const [updateStock, { isLoading: updateLoading }] = useUpdateRefundPolicyMutation();
    const [addStock, { isLoading: addLoading }] = useAddRefundPolicyMutation();
    const { data: contentDetail, refetch: refetchcontentDetail } = useGetRefundPolicyDataQuery();

    useEffect(() => {
        refetchcontentDetail();
    }, [refetchcontentDetail]);

    useEffect(() => {
        setDetailedDescription(contentDetail?.data?.content || "",);
    }, [contentDetail]);



    const validateForm = () => {
        const newErrors = {};

        if (!detailedDescription) {
            newErrors.detailedDescription = "Content is required";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            if (contentDetail?.data?.length > 0) {
                let formData = {
                    content: detailedDescription
                }

                const id = contentDetail?.data?.[0]?.id;
                await updateStock({ formData, id }).unwrap();
            } else {
                let formData = {
                    content: detailedDescription
                }

                await addStock(formData).unwrap();
            }
            alert("Content Updated Successfully")

        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };
    const handleEditorChange = (content) => {
        setDetailedDescription(content);
    };

    // if (loadingContent) return <div class="loader"></div>;
    // if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Refund Policy</h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <label className="form-label">Refund Policy</label>
                        <Editor
                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                            value={detailedDescription}
                            onEditorChange={handleEditorChange}
                            init={{
                                height: 300,
                                menubar: false,
                                plugins: [
                                    "advlist",
                                    "autolink",
                                    "lists",
                                    "link",
                                    "preview",
                                    "searchreplace",
                                    "wordcount",
                                ],
                                toolbar:
                                    "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                content_style:
                                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                paste_data_images: true,
                                paste_as_text: false,
                                paste_enable_default_filters: true,
                                removed_menuitems: "paste",
                            }}
                        />
                        {errors.detailedDescription && <p className="text-danger">{errors.detailedDescription}</p>}
                    </div>
                    <button type="submit" className="btn btn-primary mt-4" disabled={addLoading || updateLoading}>
                        {addLoading || updateLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddStock;
